import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreloadSpinnerComponent } from './preload-spinner.component';

@NgModule({
  declarations: [
    PreloadSpinnerComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PreloadSpinnerComponent,
  ]
})
export class PreloadSpinnerModule { }
